module.exports = __webpack_public_path__ + "img/community-bg.b3a9840a.webp";